import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { BehaviorSubject } from 'rxjs'
import { ColumnsConf } from '../columns-conf'
import { ProductionListPropertyDefinitionOrganizerComponent } from '../../properties/production-list-property-definition-organizer/production-list-property-definition-organizer.component'
import { AsyncPipe } from '@angular/common'

@Component({
  selector: 'app-columns-conf-detail',
  templateUrl: './columns-conf-detail.component.html',
  styleUrls: ['./columns-conf-detail.component.scss'],
  imports: [ProductionListPropertyDefinitionOrganizerComponent, AsyncPipe],
})
export class ColumnsConfDetailComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  @Input()
  public embedded: boolean

  public readonly columnsConf$ = new BehaviorSubject<ColumnsConf>(null)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {}

  /***************************************************************************
   *                                                                         *
   * Properties                                                              *
   *                                                                         *
   **************************************************************************/

  @Input()
  public set columnsConf(conf: ColumnsConf) {
    if (conf) {
      this.columnsConf$.next(conf)
    }
  }

  public get columnsConf(): ColumnsConf {
    return this.columnsConf$.getValue()
  }
}
